import { render, staticRenderFns } from "./EditPopup.vue?vue&type=template&id=28f149bc"
import script from "./EditPopup.vue?vue&type=script&lang=js"
export * from "./EditPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28f149bc')) {
      api.createRecord('28f149bc', component.options)
    } else {
      api.reload('28f149bc', component.options)
    }
    module.hot.accept("./EditPopup.vue?vue&type=template&id=28f149bc", function () {
      api.rerender('28f149bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/EditPopup.vue"
export default component.exports